// extracted by mini-css-extract-plugin
module.exports =  {"gwMediaSidebarTextContainer":"TextComponent_gwMediaSidebarTextContainer__Y1t-1"};